import React, { FC } from 'react';

import { useApi, useFetchData } from '@app/hooks';

import { useColumns } from './columns';
import { QueryTable } from '../common/table';

const StandModelsTable: FC = () => {
  const api = useApi();
  const [fetchData] = useFetchData({
    method: api.stands.getStandModels
  });


  const columns = useColumns({
    onChange: async (id, value, refetch) => {
      await api.stands.updateStandModel({ id, is_deleted: value });
      refetch();
    },
  });


  return (
    <>
      <QueryTable
        title="Модели стоек"
        columns={columns}
        fetchData={fetchData}
        canDownload
      />
    </>
  );
};

export default StandModelsTable;
